"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _models = require("@seedlang/models");
var _serializr = require("serializr");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var FAQ_ITEMS = [{
  question: 'What are reviews?',
  answer: 'Reviews are cards that are created for words or sentences that you would like to learn. They use a "spaced repetition system" to plan how often you see the card based on how well you remember it over time.'
}, {
  question: 'Where do I find my reviews?',
  answerWeb: 'Reviews can be found on the home page. This is the deck that opens your reviews:',
  answerMobile: 'Reviews can be found on the home screen. This is the deck that opens your reviews:',
  image: 'reviews_deck.png',
  imageSlug: 'reviews_deck',
  imageWidth: 200,
  imageHeight: 200,
  webRoute: 'reviews.home',
  mobileRoute: 'Home'
}, {
  question: 'How do I manage my reviews?',
  answerWeb: 'There is a "Reviews List" button on the home page that can be clicked to see a list of your reviews.',
  answerMobile: 'There is a "Reviews List" button on the home screen that can be clicked to see a list of your reviews.'
}, {
  question: 'How many reviews are too many?',
  answer: 'This is different for everyone, but a good strategy would be to make your first priority keeping up to date with your past reviews, and only adding new reviews when you are caught up.'
}];
var DeckSummaryCardWrapper = function DeckSummaryCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loadingReviewCards", _descriptor, _this);
      _initializerDefineProperty(_this, "hasLearnedWords", _descriptor2, _this);
      _initializerDefineProperty(_this, "showFaq", _descriptor3, _this);
      _initializerDefineProperty(_this, "reviewCards", _descriptor4, _this);
      _initializerDefineProperty(_this, "updatedDeckId", _descriptor5, _this);
      _this.getReviewDecks();
      if (_state.DeckUI.hasDeck) {
        if ((0, _utils.isPresent)(_this.wordCardIds)) {
          _this.getLearnedWords();
        } else {
          _this.hasLearnedWords = true;
        }
      }
      _state.AppUI.createEvent('deck - finish deck', {
        deck_id: _state.DeckUI.deck.id,
        language_id: _state.DeckUI.deck.languageId
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showCard",
      get: function get() {
        return !this.loadingReviewCards && this.hasLearnedWords;
      }
    }, {
      key: "deckId",
      get: function get() {
        return this.updatedDeckId || !_state.AppUI.reviewDeckStore.hasIndexData ? this.updatedDeckId : _state.AppUI.defaultReviewDeckId;
      }
    }, {
      key: "wordCardIds",
      get: function get() {
        if (_state.DeckUI.deck && _state.DeckUI.deck.vocabWordTranslateCards) {
          return _state.DeckUI.deck.vocabWordTranslateCards.map(function (item) {
            return item.word.id;
          });
        }
        if (_state.DeckUI.deck && _state.DeckUI.deck.pluralDeck) {
          return _state.DeckUI.deck.pluralCards.map(function (item) {
            return item.word.id;
          });
        }
        if (_state.DeckUI.deck && _state.DeckUI.deck.genderDeck) {
          return _state.DeckUI.deck.genderCards.map(function (item) {
            return item.word.id;
          });
        }
      }
    }, {
      key: "cardTypesForPotentialReview",
      get: function get() {
        return (0, _lodash.uniqBy)(this.cardsForPotentialReview.map(function (item) {
          return {
            cardTypeId: item.cardType.id,
            cardTypeName: item.cardType.name
          };
        }), 'cardTypeId');
      }
    }, {
      key: "cardsForPotentialReview",
      get: function get() {
        if (!_state.DeckUI.hasDeck) {
          return;
        }
        if (_state.DeckUI.deck.pluralDeck) {
          return _state.DeckUI.deck.pluralCards;
        } else if (_state.DeckUI.deck.conjugationDeck || _state.DeckUI.deck.conjugationWithVideoDeck) {
          return _state.DeckUI.deck.conjugationAndTranslationCards;
        } else if (_state.DeckUI.deck.genderDeck) {
          return _state.DeckUI.deck.genderCards;
        } else if (_state.DeckUI.deck.numberDeck) {
          return _state.DeckUI.deck.numberCards;
        } else if (_state.DeckUI.deck.pronunciationDeck) {
          return _state.DeckUI.deck.pronunciationCards;
        } else if (_state.DeckUI.deck.caseDeck) {
          return _state.DeckUI.deck.caseCards;
        } else {
          return _state.DeckUI.deck.translationAndComprehensionCards.concat(_state.DeckUI.deck.exerciseCards);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        try {
          if (_state.AppUI.layout.isNative) {
            _state.VocabUI.getWords();
          }
        } catch (error) {
          console.error('Error during componentWillUnmount:', error);
        }
      }
    }, {
      key: "onReviewAllForCardType",
      value: function onReviewAllForCardType(cardTypeId) {
        var _this2 = this;
        _state.AppUI.set('reloadReviewDecks', true);
        var cards = this.cardsForPotentialReview.filter(function (item) {
          return item.cardType.id === cardTypeId;
        });
        var cardIds = cards.map(function (item) {
          return item.id;
        });
        (0, _lodash.each)(cards, function (card) {
          _state.DeckUI.addCardToReviewCards(card, _this2.deckId);
        });
        _state.DeckUI.deckStore.addAllToReviews({
          ids: {
            deckId: this.deckId
          },
          data: {
            card_ids: cardIds
          }
        }, function () {
          return _state.DeckUI.getReviewCards(_this2.deckId);
        });
      }
    }, {
      key: "getLearnedWords",
      value: function getLearnedWords() {
        _state.DeckUI.wordStore.getIndex({
          queryStrings: {
            vocab_list: true
          },
          filters: {
            translation_ids: this.wordCardIds
          }
        }, this.afterGetLearnedWords);
      }
    }, {
      key: "afterGetLearnedWords",
      value: function afterGetLearnedWords(resp) {
        _state.DeckUI.wordStore.setIndexData(resp);
        this.hasLearnedWords = true;
      }
    }, {
      key: "onToggleLearned",
      value: function onToggleLearned(wordId) {
        var word = _state.DeckUI.wordStore.indexData.find(function (item) {
          return item.id === wordId;
        });
        if (word) {
          word.set('learned', !word.learned);
        } else {
          word = (0, _serializr.deserialize)(_models.Word, {
            id: wordId,
            learned: true
          });
          _state.DeckUI.wordStore.indexData.push(word);
        }
        _state.AppUI.createOrUpdateUserTranslation(word, {
          learned: word.learned
        }, this.afterCreateUserTranslation.bind(this, word));
      }
    }, {
      key: "afterCreateUserTranslation",
      value: function afterCreateUserTranslation(word, resp) {
        word.set('userTranslationId', resp.userTranslationId);
      }
    }, {
      key: "isLearned",
      value: function isLearned(wordId) {
        return wordId && _state.DeckUI.wordStore.hasIndexData && _state.DeckUI.wordStore.indexData.find(function (item) {
          return item.id === wordId && item.learned;
        });
      }
    }, {
      key: "userCardForId",
      value: function userCardForId(cardId) {
        return _state.DeckUI.userDeck.userCards.find(function (item) {
          return item.cardId === cardId;
        });
      }
    }, {
      key: "toggleShowFaq",
      value: function toggleShowFaq() {
        this.showFaq = !this.showFaq;
      }
    }, {
      key: "getReviewDecks",
      value: function getReviewDecks() {
        _state.AppUI.reviewDeckStore.getIndex({});
      }
    }, {
      key: "onSetDeckId",
      value: function onSetDeckId(deckId) {
        this.updatedDeckId = deckId;
      }
    }, {
      key: "allReviewsSelectedForCardType",
      value: function allReviewsSelectedForCardType(cardTypeId) {
        var _DeckUI$reviewCards,
          _this3 = this,
          _this$cardsForPotenti;
        var reviewingCount = (_DeckUI$reviewCards = _state.DeckUI.reviewCards) === null || _DeckUI$reviewCards === void 0 ? void 0 : _DeckUI$reviewCards.filter(function (item) {
          return item.deckId === _this3.deckId && item.cardTypeId === cardTypeId;
        }).length;
        var cardsCount = (_this$cardsForPotenti = this.cardsForPotentialReview) === null || _this$cardsForPotenti === void 0 ? void 0 : _this$cardsForPotenti.filter(function (item) {
          return item.cardType.id === cardTypeId;
        }).length;
        return reviewingCount >= cardsCount;
      }
    }, {
      key: "findReviewCardForCard",
      value: function findReviewCardForCard(card) {
        var _this4 = this;
        if (!_state.DeckUI.reviewCards) return null;
        return _state.DeckUI.reviewCards.find(function (reviewCard) {
          return (card.word && reviewCard.translationId === card.word.id || card.sentence && reviewCard.translationId === card.sentence.id) && reviewCard.cardTypeId === card.cardTypeId && reviewCard.deckId === _this4.deckId && reviewCard.pronoun === card.pronoun && reviewCard.tenseConceptId === card.tenseConceptId;
        });
      }
    }, {
      key: "getDecksWithReviewCard",
      value: function getDecksWithReviewCard(card) {
        var _DeckUI$reviewCards2,
          _this5 = this;
        if (!_state.DeckUI.reviewCards) return '';
        var decks = (_DeckUI$reviewCards2 = _state.DeckUI.reviewCards) === null || _DeckUI$reviewCards2 === void 0 || (_DeckUI$reviewCards2 = _DeckUI$reviewCards2.filter(function (reviewCard) {
          return (card.word && reviewCard.translationId === card.word.id || card.sentence && reviewCard.translationId === card.sentence.id) && reviewCard.cardTypeId === card.cardTypeId && reviewCard.deckId !== _this5.deckId;
        })) === null || _DeckUI$reviewCards2 === void 0 ? void 0 : _DeckUI$reviewCards2.map(function (reviewCard) {
          var _AppUI$filteredReview;
          return (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 || (_AppUI$filteredReview = _AppUI$filteredReview.find(function (reviewDeck) {
            return reviewDeck.id === reviewCard.deckId;
          })) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.name;
        }).filter(Boolean);
        return (decks === null || decks === void 0 ? void 0 : decks.join(', ')) || '';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          hasLearnedWords: this.hasLearnedWords,
          showCard: this.showCard,
          wordCardIds: this.wordCardIds,
          cardsForPotentialReview: this.cardsForPotentialReview,
          cardTypesForPotentialReview: this.cardTypesForPotentialReview,
          getLearnedWords: this.getLearnedWords,
          afterGetLearnedWords: this.afterGetLearnedWords,
          onToggleLearned: this.onToggleLearned,
          afterCreateUserTranslation: this.afterCreateUserTranslation,
          isLearned: this.isLearned,
          userCardForId: this.userCardForId,
          onReviewAllForCardType: this.onReviewAllForCardType,
          showFaq: this.showFaq,
          toggleShowFaq: this.toggleShowFaq,
          faqItems: FAQ_ITEMS,
          reviewDecks: _state.AppUI.filteredReviewDecks,
          reviewCards: _state.DeckUI.reviewCards,
          deckId: this.deckId,
          onSetDeckId: this.onSetDeckId,
          reviewDeckOptions: _state.AppUI.reviewDeckOptions,
          allReviewsSelectedForCardType: this.allReviewsSelectedForCardType,
          findReviewCardForCard: this.findReviewCardForCard,
          getDecksWithReviewCard: this.getDecksWithReviewCard
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loadingReviewCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "hasLearnedWords", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "showFaq", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "reviewCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "updatedDeckId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "showCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordCardIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordCardIds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypesForPotentialReview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypesForPotentialReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsForPotentialReview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsForPotentialReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onReviewAllForCardType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onReviewAllForCardType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getLearnedWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getLearnedWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetLearnedWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetLearnedWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleLearned", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleLearned"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateUserTranslation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateUserTranslation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isLearned", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "isLearned"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userCardForId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "userCardForId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleShowFaq", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleShowFaq"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getReviewDecks", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getReviewDecks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetDeckId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetDeckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allReviewsSelectedForCardType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "allReviewsSelectedForCardType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "findReviewCardForCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "findReviewCardForCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getDecksWithReviewCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getDecksWithReviewCard"), _class2.prototype), _class2)) || _class;
};
DeckSummaryCardWrapper.displayName = 'DeckSummaryCardWrapper';
var _default = exports["default"] = DeckSummaryCardWrapper;